const CheckoutActionTypes = {
  PAYMENT_START: "PAYMENT_START",
  PAYMENT_SUCCESS: "PAYMENT_SUCCESS",
  PAYMENT_ERROR: "PAYMENT_ERROR",
  CHECKOUT_COMPLETE: "CHECKOUT_COMPLETE",
};

export default CheckoutActionTypes;
